// src/views/Dashboard.jsx
import React, { useState, useEffect, useRef } from "react";
import { useNavigate, Link, Navigate } from "react-router-dom";
import {
  logout,
  hasScope,
  getUsuario,
  getActorType,
  getAccessToken,
  getClaims,
} from "../utils/auth";
import { stopSessionWatch } from "../utils/sessionManager";
/**Clientes */
import DatosClientes from "./Clientes/DatosClientes/DatosClientes";
import ActualizacionLimiteCredito from "./Clientes/ActualizacionLimiteDeCredito/ActualizacionLimiteCredito";
import ListaPines from "./Clientes/Pines/ListaPines";
import DescuentoFlota from "./Clientes/DescuentoFlota/ListaDescuento";

//Banner
import apiRoutes from "../api/apiRoutes";

/*Productos*/
import ListarProductos from "./Productos/ListaProductos/ListarProductos";
import ListarPrecioProductoEess from "./Productos/PrecioProductoEess/ListarPrecioProductoEess";
import ListarBonificacion from "./Productos/Bonificacion/ListarBonificacion";
import ListarPrecioProductoEessFuturo from "./Productos/PrecioProductoEessFuturo/ListarPrecioProductoEessFuturo";
/*Estaciones*/
import ListarEstaciones from "./Estaciones/DatosEstaciones/ListarEstaciones";
import ListarPinesPlayeros from "./Estaciones/PinesPlayeros/ListarPinesPlayeros";
import ListarPinesMaestros from "./Estaciones/PinesMaestros/ListarPinesMaestros";
/*Tarjetas*/
import ListaTarjetas from "./Tarjetas/ListadoDeTarjeta/ListaTarjetas";
import AsignarLimiteDeCreditoMasivo from "./Tarjetas/AsignarLimiteDeCreditoMasivo/AsignarLimiteDeCreditoMasivo";
import VehiculosConTarjeta from "./Tarjetas/VehiculosConTarjeta/VehiculosConTarjeta";
import SolicitarTarjeta from "./Tarjetas/NuevaTarjeta/SolicitarTarjeta";
import ProductosTarjeta from "./Tarjetas/ProductosTarjeta/ProductosTarjeta";
import AsignarEESS from "./Tarjetas/AsignarEESS/AsignarEESS";
import EESShabilitadas from "./Tarjetas/EessHabilitadasPorTarjeta/EESShabilitadas";
import ListaDeLotes from "./Tarjetas/ListaDeLotesTarjeta/ListaDeLotes";
import ConfigurarTarjeta from "./Tarjetas/Configuracion/ConfigurarTarjeta";
/**Parametros */
import ParametrosGenerales from "./ConfiguracionGeneral/ParametrosGrales/ListarParametros";
import EstadosFlujosInformacion from "./EstadosFlujos/Informacion/ListarInformacion";
import TiposEstado from "./EstadosFlujos/Tipos de estado/ListarTipoEstados";
import Estados from "./EstadosFlujos/Estados/ListarEstados";
import Procesos from "./EstadosFlujos/Procesos/ListarProcesos";
/**Catálogo comercial*/
import ListarRubro from "./EstadosFlujos/Rubro/ListarRubro";
import ListarMarca from "./EstadosFlujos/Marca/ListarMarca";
/**Geografía*/
import ListarZona from "./EstadosFlujos/Zona/ListarZona";
import ListarCiudad from "./ConfiguracionGeneral/ParametrosGrales/Geografia/Ciudad/ListarCiudad";
import ListarDepartamento from "./ConfiguracionGeneral/ParametrosGrales/Geografia/Departamento/ListarDepartamento";
/**Fiscales*/
import ListarMoneda from "./ConfiguracionGeneral/ParametrosGrales/Fiscales/Moneda/ListarMoneda";
import ListarIva from "./ConfiguracionGeneral/ParametrosGrales/Fiscales/IVA/ListarIva";

//----- Menu Auditoria y Control -----//
import ListarAuditoria from "./EstadosFlujos/Auditoria/ListarAuditoria";
import ListarTransaccionesBancard from "./EstadosFlujos/TransaccionesBancard/ListarTransaccionesBancard";
import ListarDatosExportadosProani from "./ImportExport/DatosExportadosProani/ListarDatosExportadosProani";
/* Modulo Facturacion */
import ListarFacturacionClientesPorLiquidacion from "./Facturacion/FacturacionClientesPorLiquidacion/ListarFacturacionClientesPorLiquidacion";
import ListarFacturasGeneradas from "./Facturacion/facturasGenerales/ListarFacturasGeneradas";
/* Modulo Liquidacion */
import ListarLiquidacionSemana from "./Liquidacion/LiquidacionSemanas/ListarLiquidacionSemanas";
import ListarEjecucionLiquidaciones from "./Liquidacion/EjecucionDeLiquidaciones/ListarEjecucionDeLiquidaciones";
import ListarLiquidacionesDeClientes from "./Liquidacion/LiquidacionDeClientes/ListarLiquidacionDeClientes";
import ListarLiquidacionesDeEess from "./Liquidacion/LiquidacionDeEess/ListarLiquidacionDeEess";
import ConfirmarUltimaLiquidacionActiva from "./Liquidacion/ConfirmarUltimaLiquidacionActiva/ConfirmarUltimaLiquidacionActiva";
/* Modulo Ejecuciones Manuales */
import RenovacionDeTarjetas from "./EjecucionesManuales/RenovacionDeTarjetas/RenovacionDeTarjetas";
import ImportacionSap from "./EjecucionesManuales/ImportacionSap/ImportacionSap";
import RecalcularSaldoDeTarjetas from "./EjecucionesManuales/RecalcularSaldoDeTarjetas/RecalcularSaldoDeTarjetas";
import ReinicioSaldoDeTarjetas from "./EjecucionesManuales/ReinicioSaldoDeTarjetas/ReinicioSaldoDeTarjetas";
import EjecutarProcesoDeLiquidacion from "./EjecucionesManuales/EjecutarProcesoDeLiquidacion/EjecutarProcesoDeLiquidacion";
import GenerarArchivoSap from "./ProcesosBatch/GenerarArchivoSap/GenerarArchivoSap";
import ImportarArchivoSap from "./ProcesosBatch/ImportarArchivoSap/ImportarArchivoSap";
import ListadoDeArchivos from "./EjecucionesManuales/ListadoDeArchivos/ListadoDeArchivos";
/*Roles y Accesos/seguridad*/
import ListaRoles from "./Seguridad/Roles/ListaRoles";
import ListaUsuario from "./Seguridad/Usuario/ListaUsuario";
import ListadoPermisos from "./Seguridad/Permisos/ListadoPermisos";
/* Certificados */
import VerImpuesto from "./Certificados/ImpuestoValorSelectivo/ListarImpuesto";
import ListarProdCertificado from "./Certificados/Productos de certificados/ListarProdCertificado";
import ListarCertificadoCliente from "./Certificados/CertificadoCliente/ListarCertificadoCliente";
/*Contratos*/
import ListaContratos from "./Contratos/Contratos/ListaContratos";
import ListaProductosContrato from "./Contratos/Productos del contrato/ListaProductosContrato";
import ListarContratoTarjeta from "./Contratos/Asignacion de contratos a tarjetas/ListarContratoTarjeta";
/* Transacciones (Remitos) */
import ListarRemitos from "./Transacciones/Remito_transacciones/ListarRemitos";
/*Reportes de clientes*/
import ReportePinesDeClientes from "./Reporte de clientes/Listado de Pines de Clientes/ReportePinesDeClientes";
import ReporteListadoDeTarjetas from "./Reporte de clientes/Listado de Tarjetas/ReporteListadoDeTarjetas";
import ReporteProductosAsignadosTarjetasPorCuenta from "./Reporte de clientes/Productos asignados a Tarjetas por Cuenta/ReporteProductosAsignadosTarjetasPorCuenta";
import ReporteDetalleFacturacionCliente from "./Reporte de clientes/Detalle de Facturacion Cliente/ReporteDetalleFacturacionCliente";
import ReporteDetalleUtilizacionTarjetas from "./Reporte de clientes/Detalle Utilizacion de Tarjetas/ReporteDetalleUtilizacionTarjetas";
import ReporteDetalleTarjetasConDescuento from "./Reporte de clientes/Detalle de tarjetas con descuento/ReporteDetalleTarjetasConDescuento";
import ListarTarjetaDescISC from "./Reporte de clientes/Detalle Tarjeta Decuento ISC/ListarTarjetaDescISC";
import ListarTransaccionesManuales from "./Reporte de clientes/Detalle transacciones manuales/ListarTransaccionesManuales";
import ReporteFacturacionClientes from "./Reporte de clientes/Detalle_Facturas_Clientes/ReporteFacturacionClientes";
import ReporteDetalleUtilizacionTarjetaEess from "./Reporte de clientes/Detalle utilizacion de tarjeta Eess/ReporteDetalleUtilizacionTarjetaEess";
/*Reportes de EE.SS. */
import ReporteAcreditacionEess from "./ReportesDeEess/AcreditacionDeEess/ReporteAcreditacionEess";
import ListadoDeTarjetasMaestras from "./ReportesDeEess/ListadoDeTarjetasMaestras/ListadoDeTarjetasMaestras";
import ListadoDePinesEess from "./ReportesDeEess/ListadoDePinesDeEess/ListadoDePinesDeEess";
/*Resumen de liquidacion*/
import ListarResumenLiquidacion from "./Resumen liquidacion/ListarResumenLiquidacion";

const Dashboard = () => {
  const navigate = useNavigate();
  const token = getAccessToken();

  useEffect(() => {
    if (!token) {
      navigate("/", { replace: true });
    }
  }, [token, navigate]);

  const [showModal, setShowModal] = useState(false);
  //Responsive
  const [sidebarVisible, setSidebarVisible] = useState(() => {
    // Si estamos en el navegador, obtener el ancho; si no (SSR), asumir true
    if (typeof window !== "undefined") {
      return window.innerWidth >= 768;
    }
    return true; // valor por defecto para SSR
  });

  //Ocultar imagen en mobile
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window !== "undefined") {
      return window.matchMedia("(max-width: 767px)").matches;
    }
    return false;
  });

  //Banner
  const [perfil, setPerfil] = useState(null);
  const [cargandoPerfil, setCargandoPerfil] = useState(true);
  const API_BASE = apiRoutes.login.auth.replace("/login", "");
  const [cantidadTarjetas, setCantidadTarjetas] = useState(0);
  const [noticias, setNoticias] = useState([]);

  const [openSeguridad, setOpenSeguridad] = useState(false);
  const [openSeguridad2, setOpenSeguridad2] = useState(false);
  const [openInicio, setOpenInicio] = useState(false);

  // --- Parametros (menú independiente) ---
  const [openParametrosRoot, setOpenParametrosRoot] = useState(false);
  const [openParametrosConfig, setOpenParametrosConfig] = useState(false);
  const [openParametrosEstados, setOpenParametrosEstados] = useState(false);
  const [openCatalogosComerciales, setOpenCatalogosComerciales] =
    useState(false);
  const [openGeografia, setOpenGeografia] = useState(false);
  const [openFiscales, setOpenFiscales] = useState(false);

  const [openClientes, setOpenClientes] = useState(false);
  const [openProductos, setOpenProductos] = useState(false);
  const [openEstaciones, setOpenEstaciones] = useState(false);
  const [openTarjetas, setOpenTarjetas] = useState(false);
  //Manual de usi
  const [openManualUso, setOpenManualUso] = useState(false);

  // Almacenamos la vista activa en el estado local.
  // Prioridad: 1. URL param (?view=...) dentro del hash 2. localStorage 3. Default "escritorio"
  const [activeView, setActiveView] = useState(() => {
    // En HashRouter, window.location.search suele estar vacío.
    // Los params están en window.location.hash, ej: "#/dashboard?view=..."
    const hash = window.location.hash;
    const qIndex = hash.indexOf("?");
    if (qIndex !== -1) {
      const params = new URLSearchParams(hash.substring(qIndex));
      const viewParam = params.get("view");
      if (viewParam) return viewParam;
    }
    return localStorage.getItem("dashboardActiveView") || "escritorio";
  });

  const activeViewRef = useRef(activeView);

  useEffect(() => {
    activeViewRef.current = activeView;
  }, [activeView]);

  // Sincronizar localStorage y URL cuando cambia activeView
  useEffect(() => {
    if (!getAccessToken()) return;

    localStorage.setItem("dashboardActiveView", activeView);
    navigate(`/dashboard?view=${activeView}`, { replace: true });
  }, [activeView, navigate]);

  useEffect(() => {
    if (!getAccessToken()) return;

    const basePath = window.location.pathname.startsWith("/flpa")
      ? "/flpa/"
      : "/";

    const getDashboardUrl = () => {
      const view =
        localStorage.getItem("dashboardActiveView") ||
        activeViewRef.current ||
        "escritorio";

      return `${basePath}#/dashboard?view=${view}`;
    };

    const pushTrap = () => {
      window.history.pushState({ flpaBackTrap: true }, "", getDashboardUrl());
    };

    // Creamos una entrada extra encima del Dashboard real.
    pushTrap();

    const handleBack = () => {
      if (!getAccessToken()) return;

      setShowModal(true);

      // Volvemos inmediatamente a la entrada trap,
      // sin pisar la entrada anterior del login.
      setTimeout(() => {
        window.history.go(1);
      }, 0);
    };

    window.addEventListener("popstate", handleBack);

    return () => {
      window.removeEventListener("popstate", handleBack);
    };
  }, []);

  //Banner
  useEffect(() => {
    const token = getAccessToken();
    if (!token) {
      setCargandoPerfil(false);
      return;
    }

    const claims = getClaims();
    const clienteId = claims?.clientId;
    if (!clienteId) {
      console.error("No se encontró clientId en el token");
      setCargandoPerfil(false);
      return;
    }

    // Primera petición: perfil del cliente
    fetch(`${API_BASE}/clientes/${clienteId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error("Error al cargar perfil");
        return res.json();
      })
      .then((data) => {
        setPerfil(data);
        setCargandoPerfil(false);
      })
      .catch((err) => {
        console.error(err);
        setCargandoPerfil(false);
      });

    // Segunda petición: tarjetas activas para contar
    fetch(`${API_BASE}/clientes/${clienteId}/tarjetas/activas/count`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => res.json())
      .then((data) => {
        // data.tarjetas es la lista de tarjetas activas
        setCantidadTarjetas(data.cantidad || 0);
      })
      .catch((err) => console.error("Error al cargar tarjetas:", err));

    // Obtener últimas 3 noticias (sin filtrar)
    console.log("📡 Iniciando fetch de noticias...");
    fetch(`${API_BASE}/informacion/list?page=0&size=3`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => {
        console.log("📡 Respuesta recibida, status:", res.status);
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        return res.json();
      })
      .then((data) => {
        console.log("📡 Datos parseados:", data);
        setNoticias(data.items || []);
      })
      .catch((err) => {
        console.error("❌ Error en fetch de noticias:", err);
      });
  }, []);

  //Ocultar imagen en mobile
  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 767px)");
    const handleChange = (e) => setIsMobile(e.matches);
    mediaQuery.addEventListener("change", handleChange);
    return () => mediaQuery.removeEventListener("change", handleChange);
  }, []);

  // Helper para renderizar enlaces del menú
  const renderMenuLink = (viewName, label) => {
    return (
      <a
        // Usamos #/ para que sea relativo al hash actual
        href={`#/dashboard?view=${viewName}`}
        onClick={(e) => {
          // Si es clic izquierdo simple (sin teclas modificadoras), navegación SPA
          if (!e.ctrlKey && !e.metaKey && !e.shiftKey && e.button === 0) {
            e.preventDefault();
            setActiveView(viewName);
            //
            if (window.innerWidth < 768) {
              setSidebarVisible(false);
            }
            // El useEffect se encargará de actualizar la URL
          }
        }}
        className="submenu-link-old block w-full cursor-pointer"
        style={{ textDecoration: "none", color: "inherit" }}
      >
        {label}
      </a>
    );
  };

  //Menu operaciones
  const [openOperaciones, setOpenOperaciones] = useState(false);
  const [openTransacciones, setOpenTransacciones] = useState(false);
  const [openLiquidacion, setOpenLiquidacion] = useState(false);
  const [openCertificados, setOpenCertificados] = useState(false);
  const [openContratos, setOpenContratos] = useState(false);
  const [openFacturacion, setOpenFacturacion] = useState(false);

  // --- Menu Reportes ---
  const [openMenuReportes, setOpenMenuReportes] = useState(false);
  const [openReportesClientesSub, setOpenReportesClientesSub] = useState(false);
  const [openReportesEessSub, setOpenReportesEessSub] = useState(false);
  const [openResumenLiquidacionSub, setOpenResumenLiquidacionSub] =
    useState(false);

  //Menu Auditoria y Control
  const [openAuditoriaControl, setOpenAuditoriaControl] = useState(false);
  const [openImporExport, setOpenImportExport] = useState(false);
  const [openAuditoria, setOpenAuditoria] = useState(false);
  const [openTransaccionBancard, setOpenTransaccionBancard] = useState(false);

  //Menu Ejecuciones y Procesos
  const [openEjecucionesProcesos, setEjecucionesProcesos] = useState(false);
  const [openEjecucionesManuales, setEjecucionesManuales] = useState(false);
  const [openProcesosBatch, setProcesosBatch] = useState(false);

  // ===== Scopes (solo los que usamos ahora) =====
  // Maestro Flota -> Tarjetas
  const canListaTarjetas = hasScope("listar tarjetas:list"); // Listar tarjetas (hecho)
  const canAsignarLimiteDeCreditoMasivo = hasScope(
    "límite de crédito actualización masiva:list",
  ); // Listar tarjetas (hecho)
  const canEessPorTarjeta = hasScope("eess por tarjetas:list"); // EESS por tarjetas (hecho)
  const canProductosPorTarjeta = hasScope("productos por tarjeta:list"); // Productos por tarjeta (hecho)
  const canVehiculosConTarjetas =
    hasScope("vehículos con tarjetas:list") ||
    hasScope("vehiculos con tarjetas:list"); // por las dudas sin tilde (hecho)

  const canTarjetaCliente = hasScope("tarjeta cliente:insert"); // Tarjeta Cliente (hecho, dentro de SolicitarTarjeta)
  const canTarjetaMaestra = hasScope("tarjeta maestra:insert"); // Tarjeta Maestra (hecho, dentro de SolicitarTarjeta)
  const canTarjetaPrepaga = hasScope("tarjeta pre-paga:insert"); // Tarjeta Pre-Paga (hecho, dentro de SolicitarTarjeta)
  const canSolicitarTarjeta =
    canTarjetaCliente || canTarjetaMaestra || canTarjetaPrepaga; // muestra "Solicitar una nueva Tarjeta"

  const canLoteTarjetas = hasScope("lote tarjetas:list"); // Lote Tarjetas (hecho)
  const canConfigTarjeta =
    hasScope("configuracion tarjeta:list") ||
    hasScope("configuración tarjeta:list"); // Configuracion Tarjeta (hecho)

  // Actualización Masiva = "Modificación Productos y EE.SS. de Tarjetas"
  const canAsignarMasivoEess = hasScope(
    "actualización masiva:eess_a_todas_las_tarjetas",
  );
  const canAsignarEessTarjetas = hasScope(
    "actualización masiva:asignar_eess_a_tarjetas",
  );
  const canAsignarProductosTarjetas = hasScope(
    "actualización masiva:asignar_productos_a_tarjetas",
  );
  const canActualizacionMasiva =
    canAsignarMasivoEess ||
    canAsignarEessTarjetas ||
    canAsignarProductosTarjetas;
  //hasScope("actualización masiva:list");

  // Si ningún hijo de “Tarjetas” tiene permiso, se oculta todo el bloque Tarjetas
  const hasTarjetasMenu =
    canListaTarjetas ||
    canAsignarLimiteDeCreditoMasivo ||
    canVehiculosConTarjetas ||
    canProductosPorTarjeta ||
    canEessPorTarjeta ||
    canLoteTarjetas ||
    canSolicitarTarjeta ||
    canConfigTarjeta ||
    canActualizacionMasiva;

  // Seguridad
  const canPermisos = hasScope("permisos:list");
  const canRoles = hasScope("roles:list");
  const canUsuarios = hasScope("usuarios:list");
  const canUsuariosPorRol = hasScope("usuarios por rol:list");

  const hasSeguridadMenu =
    canPermisos || canRoles || canUsuarios || canUsuariosPorRol;

  // Clientes (por ahora solo mapeamos Datos del Cliente, el resto queda listo para futuro)
  const canDatosClientes = hasScope("datos del cliente:list"); // Datos del Cliente (hecho)
  const canActLimite =
    hasScope("actualización límites de crédito:list") ||
    hasScope("actualizacion límites de crédito:list") ||
    hasScope("actualizacion limites de credito:list"); // Actualización Límites de Crédito (hecho, pero vista pendiente)
  const canPines = hasScope("pines:list"); // Pines (hecho, vista futura)
  const canDescuentoFlota = hasScope("descuento flota:list"); // Descuento Flota (hecho, vista futura)

  const hasClientesMenu =
    canDatosClientes || canActLimite || canPines || canDescuentoFlota;

  // Productos
  const canListaProductos = hasScope("lista productos:list"); // Lista Productos (hecho, vista futura)
  const canPrecioProdEess =
    hasScope("precio de productos por eess:list") ||
    hasScope("precio de productos por eess:list"); // Precio de productos por EESS (hecho, vista futura)
  const canBonificacion =
    hasScope("bonificación:list") || hasScope("bonificacion:list"); // Bonificación (hecho, vista futura)

  //Usamos 'precio de productos por eess:list' como respaldo temporal ya que aún no hay scope
  const canPrecioFuturo =
    hasScope("precio futuro:list") ||
    hasScope("precio de productos por eess:list");

  const hasProductosMenu =
    canListaProductos ||
    canPrecioProdEess ||
    canBonificacion ||
    canPrecioFuturo;

  // Estaciones
  const canListaEstaciones =
    hasScope("listar eess:list") || hasScope("listar estaciones:list"); // Listar EESS (hecho, vista futura)
  const canPinesEess = hasScope("pines eess:list"); // Pines EESS (hecho, vista futura)
  const canPinesMaestros = hasScope("pines maestros:list"); // Pines Maestros (hecho, vista futura)

  //menu operaciones
  // Transacciones
  const canTransacciones = hasScope("listar transacciones (remitos):list");

  // Liquidación
  const canLiquidacionSemanas = hasScope("liquidación (semanas):list");
  const canEjecucionLiquidacion = hasScope("ejecución de liquidaciones:list");
  const canLiquidacionClientes = hasScope("liquidación de clientes:list");
  const canLiquidacionEstaciones = hasScope("liquidación de estaciones:list");
  const canConfirmarLiquidacion = hasScope("confirmar última liq. activa:list");

  // Certificados
  const canCertificados = hasScope("certificados:list");
  const canProductosPorCertificado = hasScope("productos por certificado:list");
  const canAsignarClientesCertificado = hasScope("certificados:insert");

  //Contratos
  const canContratos = hasScope("lista de contratos:list");
  const canProductosContrato = hasScope("productos del contrato:list");
  const canContratoTarjeta = hasScope(
    "asignación de contratos a tarjetas:list",
  );

  // Facturación
  const canFacturacionClientes = hasScope(
    "facturación de clientes por liquidación:list",
  );
  const canFacturasGeneradas = hasScope("facturas generadas:list");

  // =======================
  // Menu Reportes
  // =======================

  //Repostes Clientes
  const canReportePinesClientes = hasScope("listado de pines de clientes:list");
  const canReporteListadoDeTarjetas = hasScope("listado de tarjetas:list");
  const canReporteProductosAsignados = hasScope(
    "productos asignados a tarjetas por cuenta:list",
  );
  const canReporteDetalleFacturacionCliente = hasScope(
    "detalle de facturación cliente:list",
  );
  //Va a faltar el de EE.SS.
  const canReporteDetalleUtilizacionTarjetas = hasScope(
    "detalle de utilización de tarjetas:list",
  );
  const canReporteDetalleTarjetasConDescuento = hasScope(
    "detalle de utilización de tarjetas con descuento:list",
  );
  const canDetalleUtilizacionDescuentoISC = hasScope(
    "detalle de utilización de tarjetas con descuento isc:list",
  );
  const canDetalleTransaccionesManuales = hasScope(
    "detalle de utilización transacciones manuales:list",
  );
  const canDetalleFacturacionClientes = hasScope(
    "detalle de facturacion clientes:list",
  );

  const showReportesDeClientes =
    canReportePinesClientes ||
    canReporteListadoDeTarjetas ||
    canReporteProductosAsignados ||
    canReporteDetalleFacturacionCliente ||
    canReporteDetalleUtilizacionTarjetas ||
    canReporteDetalleTarjetasConDescuento ||
    canDetalleUtilizacionDescuentoISC ||
    canDetalleTransaccionesManuales ||
    canDetalleFacturacionClientes;

  //Reportes EE.SS.
  const canListarPinesEess = hasScope("listado de pines de estaciones:list");
  const canListarTarjetasMaestras = hasScope(
    "listado de tarjetas maestras:list",
  );
  const canAcreditacionDeEess = hasScope("acreditación de ee.ss.:list");
  const canReporteDetalleUtilizacionTarjetasEESS = hasScope(
    "listado de transacciones ee.ss.:list",
  );

  const showReportesDeEess =
    canListarPinesEess ||
    canListarTarjetasMaestras ||
    canAcreditacionDeEess ||
    canReporteDetalleUtilizacionTarjetasEESS;

  // Resumen de Liquidación
  const canResumenLiquidacion = hasScope("ejecución de liquidaciones:list");
  const showReportesDeResumenLiquidacion = canResumenLiquidacion;

  const showReportes =
    showReportesDeClientes ||
    showReportesDeEess ||
    showReportesDeResumenLiquidacion;

  //-----Menu Auditoria y Control-----//
  //Import y Export
  const canImport = hasScope("datos importados proani:list");
  const canExport = hasScope("datos exportados proani:list");
  //Auditoria
  const canAuditoria = hasScope("auditoria:list");
  //Transacion Bancard
  const canTransaccionBancard = hasScope("transaccion bancard:list");

  //Ejecuciones Manuales
  const canRenovacionDeTarjetas = hasScope("renovación de tarjetas:list");
  const canImportacionSap = hasScope("importación sap:list");
  const canRecalcularSaldoDeTarjetas = hasScope(
    "recalcular saldo de tarjetas:list",
  );
  const canReiniciarSaldosDeTarjetas = hasScope(
    "reiniciar saldos de tarjetas:list",
  );
  const canListadoDeArchivos = hasScope("listado de archivos:list");
  const canEjecutarProcesoDeLiquidacion = hasScope(
    "ejecutar proceso de liquidación:list",
  );
  //Procesos Batch
  const canGenerarArchivosSap = hasScope("generar archivo sap:list");
  const canImportarArchivoSap = hasScope("importar archivo sap:list");

  //estaciones
  const hasEstacionesMenu =
    canListaEstaciones || canPinesEess || canPinesMaestros;

  //menu operaciones
  const showTransacciones = canTransacciones;

  const showLiquidacion =
    canLiquidacionSemanas ||
    canEjecucionLiquidacion ||
    canLiquidacionClientes ||
    canLiquidacionEstaciones ||
    canConfirmarLiquidacion;

  const showCertificados =
    canCertificados ||
    canProductosPorCertificado ||
    canAsignarClientesCertificado;

  const showFacturacion = canFacturacionClientes || canFacturasGeneradas;

  const showOperaciones =
    showTransacciones || showLiquidacion || showCertificados || showFacturacion;
  //menu Ejecucion y procesos
  const showEjecucionesManuales =
    canRenovacionDeTarjetas ||
    canImportacionSap ||
    canRecalcularSaldoDeTarjetas ||
    canReiniciarSaldosDeTarjetas ||
    canListadoDeArchivos ||
    canEjecutarProcesoDeLiquidacion;
  const showProcesosBatch = canGenerarArchivosSap || canImportarArchivoSap;
  const showEjecucionProcesos = showEjecucionesManuales || showProcesosBatch;
  // =======================
  // Parametros (scopes)
  // =======================
  const canParametrosGenerales =
    hasScope("parámetros generales:list") ||
    hasScope("parametros generales:list");

  const canTiposEstado =
    hasScope("tipos de estado:list") || hasScope("tipo de estado:list"); // por las dudas

  const canEstados = hasScope("estados:list");

  const canProcesos = hasScope("procesos:list");

  const canRubros = hasScope("rubros:list");

  const canMarcas = hasScope("marcas:list");

  const canZonas = hasScope("zonas:list");

  const canCiudades = hasScope("ciudades:list");

  const canDepartamentos = hasScope("departamentos:list");

  const canMonedas = hasScope("monedas:list");

  const canIvas = hasScope("iva:list");

  const showGeografia = canCiudades || canDepartamentos;

  const showFiscales = canMonedas;

  const canInformacion =
    hasScope("información:list") || hasScope("informacion:list");

  // Submenús dentro de Parametros
  const hasParametrosConfigMenu = canParametrosGenerales;
  const hasParametrosEstadosMenu =
    canInformacion || canTiposEstado || canEstados || canProcesos;

  // Menú raíz Parametros
  const hasParametrosMenu =
    hasParametrosConfigMenu ||
    hasParametrosEstadosMenu ||
    canRubros ||
    canMarcas ||
    canDepartamentos ||
    canCiudades ||
    canMonedas;

  const showCatalogosComerciales = canRubros || canMarcas;

  //Menu Auditoria y Control
  const showImportExport = canImport || canExport;

  const showAuditoria = canAuditoria;

  const showTransaccionBancard = canTransaccionBancard;

  const showAuditoriaControl =
    showImportExport || showAuditoria || showTransaccionBancard;

  const handleLogout = () => {
    // 1. Detenemos observadores de sesión
    stopSessionWatch();

    // 2. Disparamos evento de logout
    window.dispatchEvent(new Event("auth:logout"));

    // 3. Destruimos la sesión y navegamos fuera.
    // ELIMINAMOS 'setShowModal(false)' PORQUE ES REDUNDANTE Y CAUSA EL ERROR
    logout();
  };

  const usuarioMostrar = getUsuario();
  const actorType = getActorType();
  //console.log("--- ESTADO DE PERMISOS ---");
  //console.log("Usuario:", usuarioMostrar);
  //console.log("Actor Type:", actorType);
  //console.log("Tiene Menú Clientes:", hasClientesMenu);
  //console.log("Tiene Menú Reportes:", showReportes);
  //console.log("Variable canDatosClientes:", canDatosClientes);
  return (
    //paddingTop: "10px", sirve para subir la vista, colocarlo más arriba o más abajo con respecto al header
    <div
      className="app-old"
      style={{ position: "relative", paddingTop: "0px" }}
    >
      {/* Overlay para móvil cuando el sidebar está abierto */}
      {isMobile && sidebarVisible && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 35, // Por debajo del sidebar (zIndex 40) pero sobre el contenido
            cursor: "pointer",
          }}
          onClick={() => setSidebarVisible(false)}
        />
      )}

      {/* Header */}
      <header
        className="topbar-old"
        style={{ padding: 0, display: "flex", alignItems: "stretch" }}
      >
        {/* Logo Petrobras */}
        <div
          style={{
            backgroundColor: "#ffffff",
            display: "flex",
            alignItems: "center",
            paddingLeft: "7px",
            flexShrink: 0,
          }}
        >
          <img
            src="/imgs/petrobras_logo.png"
            alt="Logo 1"
            style={{ height: "44px" }}
          />
        </div>

        {/* Logo Flota */}
        <div
          style={{
            backgroundColor: "#ffffff",
            display: "flex",
            alignItems: "center",
            paddingLeft: "30px",
            flexShrink: 0,
          }}
        >
          <img
            src="/imgs/flota_logo.png"
            alt="Logo 2"
            style={{ height: "50px" }}
          />
        </div>

        {/* Banner dinámico */}
        <div
          className="banner-container"
          style={{
            backgroundColor: "#ffffff",
            display: "flex",
            alignItems: "center",
            paddingLeft: "5px",
            flex: 1,
            overflow: "hidden",
            minWidth: 0,
          }}
        >
          <img
            src="/imgs/banner.png"
            alt="Banner"
            style={{
              height: "81px",
              width: "100%",
              objectFit: "cover",
            }}
          />
        </div>

        {/* Usuario */}
        <div
          style={{
            backgroundColor: "#15803d",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            paddingRight: "50px",
            flexShrink: 0,
            minWidth: "220px",
          }}
        >
          <span style={{ color: "white" }}>Usuario: {usuarioMostrar}</span>
        </div>
      </header>

      {/* Botón toggle fuera del sidebar */}
      <div
        style={{
          position: "fixed",
          top: "80px",
          left: 0,
          zIndex: 50,
          padding: "8px",
          width: "250px",
          backgroundColor: sidebarVisible ? "#ffffff" : "transparent",
        }}
      >
        <button
          onClick={() => setSidebarVisible(!sidebarVisible)}
          className="p-2 bg-transparent rounded hover:bg-transparent flex items-center justify-center border-0"
          style={{ width: "40px", height: "40px" }}
          title={sidebarVisible ? "Ocultar menú" : "Mostrar menú"}
        >
          <i className="fas fa-bars text-black"></i>
        </button>
      </div>

      {/* Sidebar */}
      {/* mt-0 sirve para separar el side bar del header, osea separarlo, ponerlo más abajo */}
      <aside
        className={`sidebar-old mt-0 ${!sidebarVisible ? "hidden" : ""}`}
        style={{
          position: "fixed",
          top: "55px", //subir o bajar el sidebar, más arriba o más abajo
          left: 0,
          bottom: 0,
          width: 250,
          zIndex: 40,
          overflowY: "auto",
          backgroundColor: "#ffffff",
        }}
      >
        {/* Nav lateral */}
        {/* paddingBottom: '20px' crea un espacio, baja o sube Cerrar sesión */}
        <nav className="nav-old" style={{ paddingBottom: "20px" }}>
          {/* Banner: espaciador entre Header & Menú lateral*/}
          <div
            style={{ height: "0px", textAlign: "center", fontWeight: "bold" }}
          ></div>

          <div
            className="menu-item-old"
            onClick={() => {
              setActiveView("escritorio");
              if (window.innerWidth < 768) {
                setSidebarVisible(false);
              }
            }}
          >
            <i className="fas fa-th-large"></i>
            <span>Escritorio</span>
          </div>

          {/* Maestro Flota */}
          {(hasClientesMenu ||
            hasProductosMenu ||
            hasEstacionesMenu ||
            hasTarjetasMenu) && (
            <div>
              <div
                onClick={() => setOpenInicio(!openInicio)}
                className="menu-root-old"
              >
                <div className="flex items-center space-x-2">
                  <i className="fa-solid fa-house"></i>
                  <span>Maestro Flota</span>
                </div>
                <i
                  className={`fa-solid fa-chevron-${
                    openInicio ? "down" : "right"
                  } text-sm`}
                />
              </div>

              {openInicio && (
                <ul className="ml-6 mt-2 space-y-1">
                  {/* Clientes */}
                  {hasClientesMenu && (
                    <li>
                      <div
                        onClick={() => setOpenClientes(!openClientes)}
                        className="menu-root-old"
                      >
                        <span className="flex items-center space-x-2">
                          <span>Clientes</span>
                        </span>
                        <i
                          className={`fa-solid fa-chevron-${
                            openClientes ? "down" : "right"
                          } text-sm`}
                        />
                      </div>

                      {openClientes && (
                        <ul className="submenu-wrap-old">
                          {canDatosClientes && (
                            <li className="hover:opacity-30">
                              {renderMenuLink(
                                "datosClientes",
                                "Datos de Clientes",
                              )}
                            </li>
                          )}
                          {canActLimite && (
                            <li className="hover:opacity-30">
                              {renderMenuLink(
                                "ActualizacionLimiteCredito",
                                "Actualización de Límite de Crédito",
                              )}
                            </li>
                          )}
                          {canPines && (
                            <li className="hover:opacity-30">
                              {renderMenuLink("listaPines", "Pines")}
                            </li>
                          )}
                          {canDescuentoFlota && (
                            <li className="hover:opacity-30">
                              {renderMenuLink(
                                "descuentoFlota",
                                "Descuento Flota",
                              )}
                            </li>
                          )}
                        </ul>
                      )}
                    </li>
                  )}

                  {/* Productos */}
                  {hasProductosMenu && (
                    <li>
                      <div
                        onClick={() => setOpenProductos(!openProductos)}
                        className="menu-root-old"
                      >
                        <span className="flex items-center space-x-2">
                          <span>Productos</span>
                        </span>
                        <i
                          className={`fa-solid fa-chevron-${
                            openProductos ? "down" : "right"
                          } text-sm`}
                        />
                      </div>

                      {openProductos && (
                        <ul className="submenu-wrap-old">
                          {canListaProductos && (
                            <li className="hover:opacity-30">
                              {renderMenuLink(
                                "listaProductos",
                                "Lista de Productos",
                              )}
                            </li>
                          )}
                          {canPrecioProdEess && (
                            <li className="hover:opacity-30">
                              {renderMenuLink(
                                "precioDeProductosPorEstación",
                                "Precio de Productos por Estación",
                              )}
                            </li>
                          )}

                          {canPrecioFuturo && (
                            <li className="hover:opacity-30">
                              {renderMenuLink("precioFuturo", "Precio Futuro")}
                            </li>
                          )}

                          {canBonificacion && (
                            <li className="hover:opacity-30">
                              {renderMenuLink("bonificación", "Bonificación")}
                            </li>
                          )}
                        </ul>
                      )}
                    </li>
                  )}

                  {/* Estaciones */}
                  {hasEstacionesMenu && (
                    <li>
                      <div
                        onClick={() => setOpenEstaciones(!openEstaciones)}
                        className="menu-root-old"
                      >
                        <span className="flex items-center space-x-2">
                          <span>Estaciones</span>
                        </span>
                        <i
                          className={`fa-solid fa-chevron-${
                            openEstaciones ? "down" : "right"
                          } text-sm`}
                        />
                      </div>

                      {openEstaciones && (
                        <ul className="submenu-wrap-old">
                          {canListaEstaciones && (
                            <li className="hover:opacity-30">
                              {renderMenuLink(
                                "listarEstaciones",
                                "Lista Estaciones",
                              )}
                            </li>
                          )}
                          {canPinesEess && (
                            <li className="hover:opacity-30">
                              {renderMenuLink(
                                "pinesPlayeros",
                                "Pines Playeros",
                              )}
                            </li>
                          )}
                          {canPinesMaestros && (
                            <li className="hover:opacity-30">
                              {renderMenuLink(
                                "pinesMaestros",
                                "Pines Maestros",
                              )}
                            </li>
                          )}
                        </ul>
                      )}
                    </li>
                  )}

                  {/* Tarjetas */}
                  {hasTarjetasMenu && (
                    <li>
                      <div
                        onClick={() => setOpenTarjetas(!openTarjetas)}
                        className="menu-root-old"
                      >
                        <span className="flex items-center space-x-2">
                          <span>Tarjetas</span>
                        </span>
                        <i
                          className={`fa-solid fa-chevron-${
                            openTarjetas ? "down" : "right"
                          } text-sm`}
                        />
                      </div>

                      {openTarjetas && (
                        <ul className="submenu-wrap-old">
                          {canListaTarjetas && (
                            <li className="hover:opacity-30">
                              {renderMenuLink(
                                "listaTarjetas",
                                "Lista de Tarjetas",
                              )}
                            </li>
                          )}

                          {canAsignarLimiteDeCreditoMasivo && (
                            <li className="hover:opacity-30">
                              {renderMenuLink(
                                "asignarLimiteDeCreditoMasivo",
                                "Asignacion Masiva De Limite de Credito",
                              )}
                            </li>
                          )}

                          {canVehiculosConTarjetas && (
                            <li className="hover:opacity-30">
                              {renderMenuLink(
                                "vehiculosConTarjeta",
                                "Vehículos con Tarjetas",
                              )}
                            </li>
                          )}

                          {canProductosPorTarjeta && (
                            <li className="hover:opacity-30">
                              {renderMenuLink(
                                "productosTarjeta",
                                "Productos de la Tarjeta",
                              )}
                            </li>
                          )}

                          {canEessPorTarjeta && (
                            <li className="hover:opacity-30">
                              {renderMenuLink(
                                "EESShabilitadas",
                                "EE.SS. habilitadas por Tarjeta",
                              )}
                            </li>
                          )}

                          {canLoteTarjetas && (
                            <li className="hover:opacity-30">
                              {renderMenuLink(
                                "listaDeLotes",
                                "Lista de Lotes de Tarjetas",
                              )}
                            </li>
                          )}

                          {canSolicitarTarjeta && (
                            <li className="hover:opacity-30">
                              {renderMenuLink(
                                "solicitarTarjeta",
                                "Solicitar una nueva Tarjeta",
                              )}
                            </li>
                          )}

                          {canConfigTarjeta && (
                            <li className="hover:opacity-30">
                              {renderMenuLink(
                                "configurarTarjetas",
                                "Configuración de Tarjetas",
                              )}
                            </li>
                          )}

                          {canActualizacionMasiva && (
                            <li className="hover:opacity-30">
                              {renderMenuLink(
                                "asignarEESS",
                                "Modificación Productos y EE.SS. de Tarjetas",
                              )}
                            </li>
                          )}
                        </ul>
                      )}
                    </li>
                  )}
                </ul>
              )}
            </div>
          )}

          {/* ===================== OPERACIONES ===================== */}
          {showOperaciones && (
            <div>
              <div
                onClick={() => setOpenOperaciones(!openOperaciones)}
                className="menu-root-old"
              >
                <div className="flex items-center space-x-2">
                  <i className="fa-solid fa-folder-tree"></i>
                  <span>Operaciones</span>
                </div>
                <i
                  className={`fa-solid fa-chevron-${
                    openOperaciones ? "down" : "right"
                  } text-sm`}
                />
              </div>

              {openOperaciones && (
                <ul className="ml-6 mt-2 space-y-1">
                  {/* ================= TRANSACCIONES ================= */}
                  {showTransacciones && (
                    <li>
                      <div
                        onClick={() => setOpenTransacciones(!openTransacciones)}
                        className="menu-root-old"
                      >
                        <span>Transacciones</span>
                        <i
                          className={`fa-solid fa-chevron-${
                            openTransacciones ? "down" : "right"
                          } text-sm`}
                        />
                      </div>

                      {openTransacciones && (
                        <ul className="submenu-wrap-old">
                          {canTransacciones && (
                            <li className="hover:opacity-30">
                              {renderMenuLink(
                                "transaccionesRemito",
                                "Listar Transacciones (Remitos)",
                              )}
                            </li>
                          )}
                        </ul>
                      )}
                    </li>
                  )}

                  {/* ================= LIQUIDACIÓN ================= */}
                  {showLiquidacion && (
                    <li>
                      <div
                        onClick={() => setOpenLiquidacion(!openLiquidacion)}
                        className="menu-root-old"
                      >
                        <span>Liquidación</span>
                        <i
                          className={`fa-solid fa-chevron-${
                            openLiquidacion ? "down" : "right"
                          } text-sm`}
                        />
                      </div>

                      {openLiquidacion && (
                        <ul className="submenu-wrap-old">
                          {canLiquidacionSemanas && (
                            <li className="hover:opacity-30">
                              {renderMenuLink(
                                "liquidacionSemanas",
                                "Liquidación (Semanas)",
                              )}
                            </li>
                          )}
                          {canEjecucionLiquidacion && (
                            <li className="hover:opacity-30">
                              {renderMenuLink(
                                "ejecucionLiquidaciones",
                                "Ejecución de Liquidaciones",
                              )}
                            </li>
                          )}
                          {canLiquidacionClientes && (
                            <li className="hover:opacity-30">
                              {renderMenuLink(
                                "liquidacionClientes",
                                "Liquidación de Clientes",
                              )}
                            </li>
                          )}
                          {canLiquidacionEstaciones && (
                            <li className="hover:opacity-30">
                              {renderMenuLink(
                                "liquidacionEstaciones",
                                "Liquidación de Estaciones",
                              )}
                            </li>
                          )}
                          {canConfirmarLiquidacion && (
                            <li className="hover:opacity-30">
                              {renderMenuLink(
                                "confirmarLiquidacion",
                                "Confirmar última liquidación activa",
                              )}
                            </li>
                          )}
                        </ul>
                      )}
                    </li>
                  )}

                  {/* ================= CERTIFICADOS ================= */}
                  {showCertificados && (
                    <li>
                      <div
                        onClick={() => setOpenCertificados(!openCertificados)}
                        className="menu-root-old"
                      >
                        <span>Certificados</span>
                        <i
                          className={`fa-solid fa-chevron-${
                            openCertificados ? "down" : "right"
                          } text-sm`}
                        />
                      </div>

                      {openCertificados && (
                        <ul className="submenu-wrap-old">
                          {canCertificados && (
                            <li className="hover:opacity-30">
                              {renderMenuLink("certificados", "Certificados")}
                            </li>
                          )}
                          {canProductosPorCertificado && (
                            <li className="hover:opacity-30">
                              {renderMenuLink(
                                "productosPorCertificado",
                                "Productos por Certificado",
                              )}
                            </li>
                          )}
                          {canAsignarClientesCertificado && (
                            <li className="hover:opacity-30">
                              {renderMenuLink(
                                "asignarClientesCertificado",
                                "Clientes por Certificado",
                              )}
                            </li>
                          )}
                        </ul>
                      )}
                    </li>
                  )}

                  {/* ================= CONTRATOS ================= */}
                  {canContratos && (
                    <li>
                      <div
                        onClick={() => setOpenContratos(!openContratos)}
                        className="menu-root-old"
                      >
                        <span>Contratos</span>
                        <i
                          className={`fa-solid fa-chevron-${openContratos ? "down" : "right"} text-sm`}
                        />
                      </div>

                      {openContratos && (
                        <ul className="submenu-wrap-old">
                          <li className="hover:opacity-30">
                            {renderMenuLink(
                              "listaContratos",
                              "Lista de Contratos",
                            )}
                          </li>
                          {canProductosContrato && (
                            <li className="hover:opacity-30">
                              {renderMenuLink(
                                "productosContrato",
                                "Productos del Contrato",
                              )}
                            </li>
                          )}
                          {canContratoTarjeta && (
                            <li className="hover:opacity-30">
                              {renderMenuLink(
                                "contratoTarjeta",
                                "Asignación de Contratos a Tarjetas",
                              )}
                            </li>
                          )}
                        </ul>
                      )}
                    </li>
                  )}

                  {/* ================= FACTURACIÓN ================= */}
                  {showFacturacion && (
                    <li>
                      <div
                        onClick={() => setOpenFacturacion(!openFacturacion)}
                        className="menu-root-old"
                      >
                        <span>Facturación</span>
                        <i
                          className={`fa-solid fa-chevron-${
                            openFacturacion ? "down" : "right"
                          } text-sm`}
                        />
                      </div>

                      {openFacturacion && (
                        <ul className="submenu-wrap-old">
                          {canFacturacionClientes && (
                            <li className="hover:opacity-30">
                              {renderMenuLink(
                                "facturacionClientesLiquidacion",
                                "Facturación de clientes por liquidación",
                              )}
                            </li>
                          )}
                          {canFacturasGeneradas && (
                            <li className="hover:opacity-30">
                              {renderMenuLink(
                                "facturasGeneradas",
                                "Facturas Generadas",
                              )}
                            </li>
                          )}
                        </ul>
                      )}
                    </li>
                  )}
                </ul>
              )}
            </div>
          )}

          {/* ===================== REPORTES ===================== */}
          {showReportes && (
            <div>
              <div
                onClick={() => setOpenMenuReportes(!openMenuReportes)}
                className="menu-root-old"
              >
                <div className="flex items-center space-x-2">
                  {/* Icono sugerido para reportes */}
                  <i className="fa-solid fa-chart-line"></i>
                  <span>Reportes</span>
                </div>
                <i
                  className={`fa-solid fa-chevron-${
                    openMenuReportes ? "down" : "right"
                  } text-sm`}
                />
              </div>

              {openMenuReportes && (
                <ul className="ml-6 mt-2 space-y-1">
                  {/* ===================== REPORTES Clientes===================== */}
                  {showReportesDeClientes && (
                    <li>
                      <div
                        onClick={() =>
                          setOpenReportesClientesSub(!openReportesClientesSub)
                        }
                        className="menu-root-old"
                      >
                        <span>Reportes Clientes</span>
                        <i
                          className={`fa-solid fa-chevron-${
                            openReportesClientesSub ? "down" : "right"
                          } text-sm`}
                        />
                      </div>

                      {openReportesClientesSub && (
                        <ul className="submenu-wrap-old">
                          {/* Vista: Listado de pines de Clientes */}
                          {canReportePinesClientes && (
                            <li className="hover:opacity-30">
                              {renderMenuLink(
                                "reportePinesClientes",
                                "Listado de Pines",
                              )}
                            </li>
                          )}
                          {/* Vista: Listado de Tarjetas (NUEVO) */}
                          {canReporteListadoDeTarjetas && (
                            <li className="hover:opacity-30">
                              {renderMenuLink(
                                "reporteListadoDeTarjetas",
                                "Listado de Tarjetas",
                              )}
                            </li>
                          )}
                          {/*Productos asignados a Tarjetas*/}
                          {canReporteProductosAsignados && (
                            <li className="hover:opacity-30">
                              {renderMenuLink(
                                "reporteProductosAsignados",
                                "Productos asignados a Tarjetas, por Cuenta",
                              )}
                            </li>
                          )}
                          {canReporteDetalleFacturacionCliente && (
                            <li className="hover:opacity-30">
                              {renderMenuLink(
                                "reporteDetalleFacturacionCliente",
                                "Detalle de Facturación Cliente",
                              )}
                            </li>
                          )}
                          {canReporteDetalleUtilizacionTarjetas && (
                            <li className="hover:opacity-30">
                              {renderMenuLink(
                                "reporteDetalleUtilizacionTarjetas",
                                "Detalle de Utilización de Tarjetas",
                              )}
                            </li>
                          )}
                          {canReporteDetalleTarjetasConDescuento && (
                            <li className="hover:opacity-30">
                              {renderMenuLink(
                                "reporteDetalleTarjetasConDescuento",
                                "Detalle de Tarjetas con Descuento",
                              )}
                            </li>
                          )}
                          {canDetalleUtilizacionDescuentoISC && (
                            <li className="hover:opacity-30">
                              {renderMenuLink(
                                "listarDetalleUtilizacionDescuentoISC",
                                "Detalle de Utilización de Tarjetas con Descuentos ISC",
                              )}
                            </li>
                          )}
                          {canDetalleTransaccionesManuales && (
                            <li className="hover:opacity-30">
                              {renderMenuLink(
                                "listarTransaccionesManuales",
                                "Detalle de Transacciones Manuales",
                              )}
                            </li>
                          )}
                          {canDetalleFacturacionClientes && (
                            <li className="hover:opacity-30">
                              {renderMenuLink(
                                "reporteFacturacionClientes",
                                "Detalle Facturación Clientes",
                              )}
                            </li>
                          )}
                        </ul>
                      )}
                    </li>
                  )}
                  {/* ===================== Reportes EE.SS.===================== */}
                  {showReportesDeEess && (
                    <li>
                      <div
                        onClick={() =>
                          setOpenReportesEessSub(!openReportesEessSub)
                        }
                        className="menu-root-old"
                      >
                        <span>Reportes EE.SS.</span>
                        <i
                          className={`fa-solid fa-chevron-${
                            openReportesEessSub ? "down" : "right"
                          } text-sm`}
                        />
                      </div>

                      {openReportesEessSub && (
                        <ul className="submenu-wrap-old">
                          {/* Vista: Listado de pines de Clientes */}
                          {canListarPinesEess && (
                            <li className="hover:opacity-30">
                              {renderMenuLink(
                                "listarPinesEstaciones",
                                "Listado de pines de Estaciones",
                              )}
                            </li>
                          )}
                          {/* Vista: Detalle de Utilización de Tarjetas Eess */}
                          {canReporteDetalleUtilizacionTarjetasEESS && (
                            <li className="hover:opacity-30">
                              {renderMenuLink(
                                "detalleUtilizacionTarjetaEess",
                                "Listado de transacciones EE.SS.",
                              )}
                            </li>
                          )}
                          {/* Vista: Listado de Tarjetas (NUEVO) */}
                          {canListarTarjetasMaestras && (
                            <li className="hover:opacity-30">
                              {renderMenuLink(
                                "listarTarjetasMaestras",
                                "Listado de Tarjetas Maestras",
                              )}
                            </li>
                          )}
                          {/*Productos asignados a Tarjetas*/}
                          {canAcreditacionDeEess && (
                            <li className="hover:opacity-30">
                              {renderMenuLink(
                                "reporteAcreditacionEess",
                                "Acreditación de EE.SS.",
                              )}
                            </li>
                          )}
                        </ul>
                      )}
                    </li>
                  )}
                  {/* ===================== Resumen de liquidacion ===================== */}
                  {showReportesDeResumenLiquidacion && (
                    <li>
                      <div
                        onClick={() =>
                          setOpenResumenLiquidacionSub(
                            !openResumenLiquidacionSub,
                          )
                        }
                        className="menu-root-old"
                      >
                        <span>Resumen de liquidacion</span>
                        <i
                          className={`fa-solid fa-chevron-${
                            openResumenLiquidacionSub ? "down" : "right"
                          } text-sm`}
                        />
                      </div>

                      {openResumenLiquidacionSub && (
                        <ul className="submenu-wrap-old">
                          <li className="hover:opacity-30">
                            {renderMenuLink(
                              "resumenLiquidacion",
                              "Resumen liquidación",
                            )}
                          </li>
                        </ul>
                      )}
                    </li>
                  )}
                </ul>
              )}
            </div>
          )}

          {/* ===================== Ejecuciones y Procesos ===================== */}
          {showEjecucionProcesos && (
            <div>
              <div
                onClick={() => setEjecucionesProcesos(!openEjecucionesProcesos)}
                className="menu-root-old"
              >
                <div className="flex items-center space-x-2">
                  <i className="fa-solid fa-play"></i>
                  <span>Ejecuciones y Procesos</span>
                </div>
                <i
                  className={`fa-solid fa-chevron-${
                    openEjecucionesProcesos ? "down" : "right"
                  } text-sm`}
                />
              </div>

              {openEjecucionesProcesos && (
                <ul className="ml-6 mt-2 space-y-1">
                  {/* ================= Ejecuciones Manuales ================= */}
                  {showEjecucionesManuales && (
                    <li>
                      <div
                        onClick={() =>
                          setEjecucionesManuales(!openEjecucionesManuales)
                        }
                        className="menu-root-old"
                      >
                        <span>Ejecuciones Manuales</span>
                        <i
                          className={`fa-solid fa-chevron-${
                            openEjecucionesManuales ? "down" : "right"
                          } text-sm`}
                        />
                      </div>

                      {openEjecucionesManuales && (
                        <ul className="submenu-wrap-old">
                          {canRenovacionDeTarjetas && (
                            <li className="hover:opacity-30">
                              {renderMenuLink(
                                "renovacionDeTarjetas",
                                "Renovación de Tarjetas",
                              )}
                            </li>
                          )}
                        </ul>
                      )}
                      {openEjecucionesManuales && (
                        <ul className="submenu-wrap-old">
                          {canImportacionSap && (
                            <li className="hover:opacity-30">
                              {renderMenuLink(
                                "importacionSap",
                                "Importacion SAP",
                              )}
                            </li>
                          )}
                        </ul>
                      )}
                      {openEjecucionesManuales && (
                        <ul className="submenu-wrap-old">
                          {canRecalcularSaldoDeTarjetas && (
                            <li className="hover:opacity-30">
                              {renderMenuLink(
                                "recalcularSaldoDeTarjetas",
                                "Recalcular Saldo de Tarjetas",
                              )}
                            </li>
                          )}
                        </ul>
                      )}
                      {openEjecucionesManuales && (
                        <ul className="submenu-wrap-old">
                          {canReiniciarSaldosDeTarjetas && (
                            <li className="hover:opacity-30">
                              {renderMenuLink(
                                "reiniciarSaldosDeTarjetas",
                                "Reiniciar Saldos de Tarjetas",
                              )}
                            </li>
                          )}
                        </ul>
                      )}
                      {openEjecucionesManuales && (
                        <ul className="submenu-wrap-old">
                          {canListadoDeArchivos && (
                            <li className="hover:opacity-30">
                              {renderMenuLink(
                                "listadoDeArchivos",
                                "Listado de Archivos",
                              )}
                            </li>
                          )}
                        </ul>
                      )}
                      {openEjecucionesManuales && (
                        <ul className="submenu-wrap-old">
                          {canEjecutarProcesoDeLiquidacion && (
                            <li className="hover:opacity-30">
                              {renderMenuLink(
                                "ejecutarProcesoDeLiquidacion",
                                "Ejecutar proceso de Liquidación",
                              )}
                            </li>
                          )}
                        </ul>
                      )}
                    </li>
                  )}

                  {/* ================= Procesos Batch ================= */}
                  {showProcesosBatch && (
                    <li>
                      <div
                        onClick={() => setProcesosBatch(!openProcesosBatch)}
                        className="menu-root-old"
                      >
                        <span>Procesos Batch</span>
                        <i
                          className={`fa-solid fa-chevron-${
                            openProcesosBatch ? "down" : "right"
                          } text-sm`}
                        />
                      </div>

                      {openProcesosBatch && (
                        <ul className="submenu-wrap-old">
                          {canGenerarArchivosSap && (
                            <li className="hover:opacity-30">
                              {renderMenuLink(
                                "generarArchivoSap",
                                "Generar Archivo SAP",
                              )}
                            </li>
                          )}
                        </ul>
                      )}
                      {openProcesosBatch && (
                        <ul className="submenu-wrap-old">
                          {canImportarArchivoSap && (
                            <li className="hover:opacity-30">
                              {renderMenuLink(
                                "importarArchivoSap",
                                "Importar Archivo SAP",
                              )}
                            </li>
                          )}
                        </ul>
                      )}
                    </li>
                  )}
                </ul>
              )}
            </div>
          )}

          {/* Roles y Accesos */}
          {hasSeguridadMenu && (
            <div>
              <div
                onClick={() => setOpenSeguridad(!openSeguridad)}
                className="menu-root-old"
              >
                <div className="flex items-center space-x-2">
                  <i className="fas fa-user-shield"></i>
                  <span>Roles y Accesos</span>
                </div>
                <i
                  className={`fa-solid fa-chevron-${
                    openSeguridad ? "down" : "right"
                  } text-sm`}
                />
              </div>

              {openSeguridad && (
                <ul className="ml-6 mt-2 space-y-1">
                  <li>
                    <div
                      onClick={() => setOpenSeguridad2(!openSeguridad2)}
                      className="menu-root-old"
                    >
                      <span className="flex items-center space-x-2">
                        <span>Seguridad</span>
                      </span>
                      <i
                        className={`fa-solid fa-chevron-${
                          openSeguridad2 ? "down" : "right"
                        } text-sm`}
                      />
                    </div>

                    {openSeguridad2 && (
                      <ul className="submenu-wrap-old">
                        {canPermisos && (
                          <li className="hover:opacity-30">
                            {renderMenuLink("listadoPermisos", "Permisos")}
                          </li>
                        )}
                        {canRoles && (
                          <li className="hover:opacity-30">
                            {renderMenuLink("listaRoles", "Roles")}
                          </li>
                        )}
                        {canUsuarios && (
                          <li className="hover:opacity-30">
                            {renderMenuLink("listaUsuario", "Usuarios")}
                          </li>
                        )}
                      </ul>
                    )}
                  </li>
                </ul>
              )}
            </div>
          )}

          {/* Parametros */}
          {hasParametrosMenu && (
            <div>
              <div
                onClick={() => setOpenParametrosRoot(!openParametrosRoot)}
                className="menu-root-old"
              >
                <div className="flex items-center space-x-2">
                  <i className="fa-solid fa-gear"></i>
                  <span>Parámetros</span>
                </div>
                <i
                  className={`fa-solid fa-chevron-${
                    openParametrosRoot ? "down" : "right"
                  } text-sm`}
                />
              </div>

              {openParametrosRoot && (
                <ul className="ml-6 mt-2 space-y-1">
                  {/* CONFIGURACIÓN GENERAL */}
                  {hasParametrosConfigMenu && (
                    <li>
                      <div
                        onClick={() =>
                          setOpenParametrosConfig(!openParametrosConfig)
                        }
                        className="menu-root-old"
                      >
                        <span className="flex items-center space-x-2">
                          <span>Configuración Gral</span>
                        </span>
                        <i
                          className={`fa-solid fa-chevron-${
                            openParametrosConfig ? "down" : "right"
                          } text-sm`}
                        />
                      </div>

                      {openParametrosConfig && (
                        <ul className="submenu-wrap-old">
                          {canParametrosGenerales && (
                            <li className="hover:opacity-30">
                              {renderMenuLink(
                                "datosParametros",
                                "Parámetros Generales",
                              )}
                            </li>
                          )}
                        </ul>
                      )}
                    </li>
                  )}

                  {/* ESTADOS Y FLUJOS */}
                  {hasParametrosEstadosMenu && (
                    <li>
                      <div
                        onClick={() =>
                          setOpenParametrosEstados(!openParametrosEstados)
                        }
                        className="menu-root-old"
                      >
                        <span className="flex items-center space-x-2">
                          <span>Estados y flujos</span>
                        </span>
                        <i
                          className={`fa-solid fa-chevron-${
                            openParametrosEstados ? "down" : "right"
                          } text-sm`}
                        />
                      </div>

                      {openParametrosEstados && (
                        <ul className="submenu-wrap-old">
                          {canInformacion && (
                            <li className="hover:opacity-30">
                              {renderMenuLink(
                                "listarInformacion",
                                "Información",
                              )}
                            </li>
                          )}

                          {canTiposEstado && (
                            <li className="hover:opacity-30">
                              {renderMenuLink(
                                "listarTipoEstados",
                                "Tipos de estado",
                              )}
                            </li>
                          )}

                          {canEstados && (
                            <li className="hover:opacity-30">
                              {renderMenuLink("listarEstados", "Estados")}
                            </li>
                          )}

                          {canProcesos && (
                            <li className="hover:opacity-30">
                              {renderMenuLink("listarProcesos", "Procesos")}
                            </li>
                          )}
                          {canZonas && (
                            <li className="hover:opacity-30">
                              {renderMenuLink("listarZona", "Zonas")}
                            </li>
                          )}
                        </ul>
                      )}
                    </li>
                  )}
                  {/* Catálogos Comerciales */}
                  {showCatalogosComerciales && (
                    <li>
                      <div
                        onClick={() =>
                          setOpenCatalogosComerciales(!openCatalogosComerciales)
                        }
                        className="menu-root-old"
                      >
                        <span className="flex items-center space-x-2">
                          <span>Catálogos Comerciales</span>
                        </span>
                        <i
                          className={`fa-solid fa-chevron-${
                            openCatalogosComerciales ? "down" : "right"
                          } text-sm`}
                        />
                      </div>

                      {openCatalogosComerciales && (
                        <ul className="submenu-wrap-old">
                          {canRubros && (
                            <li className="hover:opacity-30">
                              {renderMenuLink("listarRubro", "Rubros")}
                            </li>
                          )}
                          {canMarcas && (
                            <li className="hover:opacity-30">
                              {renderMenuLink("listarMarca", "Marcas")}
                            </li>
                          )}
                        </ul>
                      )}
                    </li>
                  )}
                  {/* Geografía */}
                  {showGeografia && (
                    <li>
                      <div
                        onClick={() => setOpenGeografia(!openGeografia)}
                        className="menu-root-old"
                      >
                        <span className="flex items-center space-x-2">
                          <span>Geografía</span>
                        </span>
                        <i
                          className={`fa-solid fa-chevron-${openGeografia ? "down" : "right"} text-sm`}
                        />
                      </div>
                      {openGeografia && (
                        <ul className="submenu-wrap-old">
                          {canCiudades && (
                            <li className="hover:opacity-30">
                              <span
                                onClick={() => setActiveView("listarCiudad")}
                                className="submenu-link-old"
                              >
                                Ciudades
                              </span>
                            </li>
                          )}
                          {canDepartamentos && (
                            <li className="hover:opacity-30">
                              <span
                                onClick={() =>
                                  setActiveView("listarDepartamento")
                                }
                                className="submenu-link-old"
                              >
                                Departamentos
                              </span>
                            </li>
                          )}
                        </ul>
                      )}
                    </li>
                  )}
                  {/* Fiscales */}
                  {showFiscales && (
                    <li>
                      <div
                        onClick={() => setOpenFiscales(!openFiscales)}
                        className="menu-root-old"
                      >
                        <span className="flex items-center space-x-2">
                          <span>Fiscales</span>
                        </span>
                        <i
                          className={`fa-solid fa-chevron-${openFiscales ? "down" : "right"} text-sm`}
                        />
                      </div>
                      {openFiscales && (
                        <ul className="submenu-wrap-old">
                          {canMonedas && (
                            <li className="hover:opacity-30">
                              <span
                                onClick={() => setActiveView("listarMoneda")}
                                className="submenu-link-old"
                              >
                                Monedas
                              </span>
                            </li>
                          )}
                          {canIvas && (
                            <li className="hover:opacity-30">
                              <span
                                onClick={() => setActiveView("listarIva")}
                                className="submenu-link-old"
                              >
                                IVA
                              </span>
                            </li>
                          )}
                        </ul>
                      )}
                    </li>
                  )}
                </ul>
              )}
            </div>
          )}

          {/* ===================== Menu Auditoria y Control ===================== */}
          {showAuditoriaControl && (
            <div>
              <div
                onClick={() => setOpenAuditoriaControl(!openAuditoriaControl)}
                className="menu-root-old"
              >
                <div className="flex items-center space-x-2">
                  <i className="fa-solid fa-list"></i>
                  <span>Auditoría y Control</span>
                </div>
                <i
                  className={`fa-solid fa-chevron-${
                    openAuditoriaControl ? "down" : "right"
                  } text-sm`}
                />
              </div>

              {openAuditoriaControl && (
                <ul className="ml-6 mt-2 space-y-1">
                  {/* ================= Import y Export ================= */}
                  {showImportExport && (
                    <li>
                      <div
                        onClick={() => setOpenImportExport(!openImporExport)}
                        className="menu-root-old"
                      >
                        <span>Import y Export</span>
                        <i
                          className={`fa-solid fa-chevron-${
                            openImporExport ? "down" : "right"
                          } text-sm`}
                        />
                      </div>

                      {openImporExport && (
                        <ul className="submenu-wrap-old">
                          {canImport && (
                            <li className="hover:opacity-30">
                              {renderMenuLink(
                                "datosImportadosProani",
                                "Datos importados Proani",
                              )}
                            </li>
                          )}
                        </ul>
                      )}

                      {openImporExport && (
                        <ul className="submenu-wrap-old">
                          {canExport && (
                            <li className="hover:opacity-30">
                              {renderMenuLink(
                                "datosExportadosProani",
                                "Datos exportados Proani",
                              )}
                            </li>
                          )}
                        </ul>
                      )}
                    </li>
                  )}

                  {/* ================= Auditoria ================= */}
                  {showAuditoria && (
                    <li>
                      <div
                        onClick={() => setOpenAuditoria(!openAuditoria)}
                        className="menu-root-old"
                      >
                        <span>Auditoría</span>
                        <i
                          className={`fa-solid fa-chevron-${
                            openAuditoria ? "down" : "right"
                          } text-sm`}
                        />
                      </div>

                      {openAuditoria && (
                        <ul className="submenu-wrap-old">
                          {canAuditoria && (
                            <li className="hover:opacity-30">
                              {renderMenuLink(
                                "auditoria",
                                actorType === "CLIENTE"
                                  ? "Control de Cambios"
                                  : "Listar Auditoría",
                              )}
                            </li>
                          )}
                        </ul>
                      )}
                    </li>
                  )}

                  {/* ================= Transaccion Bancard ================= */}
                  {showTransaccionBancard && (
                    <li>
                      <div
                        onClick={() =>
                          setOpenTransaccionBancard(!openTransaccionBancard)
                        }
                        className="menu-root-old"
                      >
                        <span>Transacción Bancard</span>
                        <i
                          className={`fa-solid fa-chevron-${
                            openTransaccionBancard ? "down" : "right"
                          } text-sm`}
                        />
                      </div>

                      {openTransaccionBancard && (
                        <ul className="submenu-wrap-old">
                          {canTransaccionBancard && (
                            <li className="hover:opacity-30">
                              {renderMenuLink(
                                "transaccionBancard",
                                "Transacción Bancard",
                              )}
                            </li>
                          )}
                        </ul>
                      )}
                    </li>
                  )}
                </ul>
              )}
            </div>
          )}

          {/* ===================== Manual de uso ===================== */}
          <div>
            <div
              onClick={() => setOpenManualUso(!openManualUso)}
              className="menu-root-old"
            >
              <div className="flex items-center space-x-2">
                <i className="fa-solid fa-book"></i>
                <span>Manual de uso</span>
              </div>
              <i
                className={`fa-solid fa-chevron-${
                  openManualUso ? "down" : "right"
                } text-sm`}
              />
            </div>

            {openManualUso && (
              <ul className="ml-6 mt-2 space-y-1">
                <li className="hover:opacity-30">
                  <a
                    href="/Manual_de_Uso.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="submenu-link-old block w-full cursor-pointer"
                    style={{ textDecoration: "none", color: "inherit" }}
                    onClick={() => {
                      if (window.innerWidth < 768) {
                        setSidebarVisible(false);
                      }
                    }}
                  >
                    <i className="fas fa-file-pdf mr-2"></i> Abrir PDF
                  </a>
                </li>
              </ul>
            )}
          </div>

          {/* Cerrar sesión */}
          <div
            className="flex items-center space-x-2 hover:text-red-600 cursor-pointer"
            onClick={() => setShowModal(true)}
          >
            <i className="fas fa-sign-out-alt"></i>
            <span>Cerrar sesión</span>
          </div>
        </nav>
      </aside>

      {/* Banner */}
      {/* Main Content */}
      <div
        className="main-wrap-old"
        style={{
          marginLeft: isMobile ? 0 : sidebarVisible ? 250 : 0,
          paddingLeft: isMobile ? "10px" : "0", //Mover el cuadro de texto a la derecha
          transition: "margin-left 0.2s ease",
        }}
      >
        <main className="main-pad-old" style={{ marginTop: "20px" }}>
          {" "}
          {/* marginTop: '-10px' sube o baja el contenido/vista, osea acercao aleja al header */}
          {activeView === "escritorio" &&
            (() => {
              // Contenido para CLIENTE
              if (actorType === "CLIENTE") {
                return (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: isMobile ? "column" : "row",
                      maxWidth: "1400px",
                      marginLeft: "20px",
                      marginRight: "20px",
                      width: "100%",
                      alignItems: "stretch",
                      marginTop: isMobile ? "20px" : "20px",
                    }}
                  >
                    {/* Imagen pantalla_principal */}
                    <div
                      style={{
                        flex: "1",
                        display: isMobile ? "none" : "block",
                      }}
                    >
                      <img
                        src="/imgs/pantalla_principal_new.png"
                        alt="Decoración"
                        style={{
                          width: "100%",
                          height: "100%",
                          display: "block",
                          objectFit: "cover",
                        }}
                        className="home-img-old"
                      />
                    </div>

                    {/* Cuadro de texto */}
                    <div
                      style={{
                        flex: "1",
                        backgroundColor: "#15803d",
                        color: "white",
                        padding: "30px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-start",
                      }}
                    >
                      {cargandoPerfil ? (
                        <p>Cargando datos...</p>
                      ) : perfil ? (
                        <>
                          <h2
                            style={{
                              fontSize: "1.4rem",
                              fontWeight: "bold",
                              marginBottom: "15px",
                            }}
                          >
                            ¡Bienvenido {perfil.nombre}!
                          </h2>

                          <div
                            style={{ fontSize: "1.2rem", lineHeight: "1.6" }}
                          >
                            <p>
                              Tus tarjetas:{" "}
                              <strong>
                                {cantidadTarjetas}
                                {canListaTarjetas && (
                                  <a
                                    href="#/dashboard?view=listaTarjetas"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      setActiveView("listaTarjetas");
                                      if (window.innerWidth < 768) {
                                        setSidebarVisible(false);
                                      }
                                    }}
                                    style={{
                                      textDecoration: "underline",
                                      color: "inherit",
                                      cursor: "pointer",
                                      marginLeft: "5px",
                                    }}
                                  >
                                    (ver lista)
                                  </a>
                                )}
                              </strong>
                            </p>
                            <p>
                              Tu línea de crédito:{" "}
                              <strong>
                                {perfil.valorCreditomaximo?.toLocaleString(
                                  "es",
                                ) || "0"}
                              </strong>
                            </p>
                            <p>
                              Saldo asignado:{" "}
                              <strong>
                                {(
                                  perfil.valorCreditomaximo - perfil.saldo
                                )?.toLocaleString("es") || "0"}
                              </strong>
                            </p>
                            <p>
                              Saldo disponible:{" "}
                              <strong>
                                {perfil.saldo?.toLocaleString("es") || "0"}
                              </strong>
                            </p>
                          </div>

                          <div
                            style={{
                              backgroundColor: "#facc15",
                              color: "#15803d",
                              borderRadius: "15px",
                              padding: "15px",
                              marginTop: "20px",
                            }}
                          >
                            <strong
                              style={{ display: "block", marginBottom: "5px" }}
                            >
                              INFORMACIONES
                            </strong>
                            {noticias.length > 0 ? (
                              noticias.map((noticia, index) => (
                                <div
                                  key={noticia.id}
                                  style={{
                                    fontSize: "1.2rem",
                                    marginBottom:
                                      index < noticias.length - 1 ? "5px" : 0,
                                  }}
                                >
                                  &gt; {noticia.descripcion}
                                </div>
                              ))
                            ) : (
                              <span style={{ fontSize: "0.8rem" }}>
                                No hay informaciones
                              </span>
                            )}
                          </div>
                        </>
                      ) : (
                        <p>No se pudo cargar la información del usuario.</p>
                      )}
                    </div>
                  </div>
                );
              }

              // Contenido para otros roles (ADMIN, EESS, etc.) - mismo diseño, texto genérico
              return (
                <div
                  style={{
                    display: "flex",
                    flexDirection: isMobile ? "column" : "row",
                    maxWidth: "1400px",
                    marginLeft: "20px",
                    marginRight: "20px",
                    width: "100%",
                    alignItems: "stretch",
                    marginTop: isMobile ? "20px" : "20px", //subir o bajar el cuadro + imagen hacia arriba o hacia abajo
                  }}
                >
                  {/* Imagen */}
                  <div
                    style={{ flex: "1", display: isMobile ? "none" : "block" }}
                  >
                    <img
                      src="/imgs/pantalla_principal_new.png"
                      alt="Decoración"
                      style={{
                        width: "100%",
                        height: "100%",
                        display: "block",
                        objectFit: "cover",
                      }}
                      className="home-img-old"
                    />
                  </div>

                  {/* Cuadro de texto genérico */}
                  <div
                    style={{
                      flex: "1",
                      backgroundColor: "#15803d",
                      color: "white",
                      padding: "30px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "flex-start",
                    }}
                  >
                    <h2
                      style={{
                        fontSize: "2rem",
                        fontWeight: "bold",
                        marginBottom: "15px",
                      }}
                    >
                      ¡Bienvenido{" "}
                      {actorType === "ADMIN"
                        ? "Administrador"
                        : actorType === "EESS"
                          ? "Estación de Servicio"
                          : "Usuario"}{" "}
                      {usuarioMostrar}!
                    </h2>
                    {/* <p style={{ fontSize: "0.95rem", lineHeight: "1.6" }}>
                      En el menú tenés disponible todas las opciones.
                    </p> */}
                  </div>
                </div>
              );
            })()}
          {/* Roles y Accesos/Seguridad */}
          {activeView === "listadoPermisos" && canPermisos && (
            <ListadoPermisos />
          )}
          {activeView === "listaRoles" && canRoles && <ListaRoles />}
          {activeView === "listaUsuario" && canUsuarios && <ListaUsuario />}
          {/* Clientes */}
          {activeView === "datosClientes" && canDatosClientes && (
            <DatosClientes />
          )}
          {activeView === "ActualizacionLimiteCredito" && canActLimite && (
            <ActualizacionLimiteCredito />
          )}
          {activeView === "listaPines" && canPines && <ListaPines />}
          {activeView === "descuentoFlota" && canDescuentoFlota && (
            <DescuentoFlota />
          )}
          {/* Productos */}
          {activeView === "listaProductos" && canListaProductos && (
            <ListarProductos />
          )}
          {activeView === "precioDeProductosPorEstación" &&
            canPrecioProdEess && <ListarPrecioProductoEess />}
          {activeView === "precioFuturo" && canPrecioFuturo && (
            <ListarPrecioProductoEessFuturo />
          )}
          {activeView === "bonificación" && canBonificacion && (
            <ListarBonificacion />
          )}
          {/* Estaciones */}
          {activeView === "listarEstaciones" && canListaEstaciones && (
            <ListarEstaciones />
          )}
          {activeView === "pinesPlayeros" && canPinesEess && (
            <ListarPinesPlayeros />
          )}
          {activeView === "pinesMaestros" && canPinesMaestros && (
            <ListarPinesMaestros />
          )}
          {/* Transacciones (Remitos) */}
          {activeView === "transaccionesRemito" && canTransacciones && (
            <ListarRemitos />
          )}
          {/* Certificados */}
          {activeView === "certificados" && canCertificados && <VerImpuesto />}
          {activeView === "productosPorCertificado" &&
            canProductosPorCertificado && <ListarProdCertificado />}
          {activeView === "asignarClientesCertificado" &&
            canAsignarClientesCertificado && <ListarCertificadoCliente />}
          {/* Contratos */}
          {activeView === "listaContratos" && canContratos && (
            <ListaContratos />
          )}
          {activeView === "productosContrato" && canProductosContrato && (
            <ListaProductosContrato />
          )}
          {activeView === "contratoTarjeta" && canContratoTarjeta && (
            <ListarContratoTarjeta />
          )}
          {/* Tarjetas */}
          {activeView === "listaTarjetas" && canListaTarjetas && (
            <ListaTarjetas />
          )}
          {/* AsignarLimiteDeCreditoMasivo */}
          {activeView === "asignarLimiteDeCreditoMasivo" &&
            canAsignarLimiteDeCreditoMasivo && <AsignarLimiteDeCreditoMasivo />}
          {activeView === "vehiculosConTarjeta" && canVehiculosConTarjetas && (
            <VehiculosConTarjeta />
          )}
          {activeView === "productosTarjeta" && canProductosPorTarjeta && (
            <ProductosTarjeta />
          )}
          {activeView === "EESShabilitadas" && canEessPorTarjeta && (
            <EESShabilitadas />
          )}
          {activeView === "listaDeLotes" && canLoteTarjetas && <ListaDeLotes />}
          {activeView === "solicitarTarjeta" && canSolicitarTarjeta && (
            <SolicitarTarjeta />
          )}
          {activeView === "configurarTarjetas" && canConfigTarjeta && (
            <ConfigurarTarjeta />
          )}
          {activeView === "asignarEESS" && canActualizacionMasiva && (
            <AsignarEESS />
          )}
          {/* // ===== Facturacion de clientes por liquidacion =====*/}
          {activeView === "facturacionClientesLiquidacion" &&
            canFacturacionClientes && (
              <ListarFacturacionClientesPorLiquidacion />
            )}
          {/* // ===== Facturacion de clientes por liquidacion =====*/}
          {activeView === "facturasGeneradas" && canFacturasGeneradas && (
            <ListarFacturasGeneradas />
          )}
          {/* // ===== Liquidacion semanas =====*/}
          {activeView === "liquidacionSemanas" && canLiquidacionSemanas && (
            <ListarLiquidacionSemana />
          )}
          {/* // ===== Ejecucion de Liquidaciones =====*/}
          {activeView === "ejecucionLiquidaciones" &&
            canEjecucionLiquidacion && <ListarEjecucionLiquidaciones />}
          {/* // ===== Liquidaciones de clientes=====*/}
          {activeView === "liquidacionClientes" && canLiquidacionClientes && (
            <ListarLiquidacionesDeClientes />
          )}
          {/* // ===== Liquidaciones de estaciones=====*/}
          {activeView === "liquidacionEstaciones" &&
            canLiquidacionEstaciones && <ListarLiquidacionesDeEess />}
          {/* // ===== Confirmar Ultima Liquidacion=====*/}
          {activeView === "confirmarLiquidacion" && canConfirmarLiquidacion && (
            <ConfirmarUltimaLiquidacionActiva onRedirect={setActiveView} />
          )}
          {/* // ===== Renovacion de Tarjetas=====*/}
          {activeView === "renovacionDeTarjetas" && canRenovacionDeTarjetas && (
            <RenovacionDeTarjetas onRedirect={setActiveView} />
          )}
          {/* // ===== Importacion SAP =====*/}
          {activeView === "importacionSap" && canImportacionSap && (
            <ImportacionSap />
          )}
          {/* // ===== Recalcular Saldo de Tarjetas=====*/}
          {activeView === "recalcularSaldoDeTarjetas" &&
            canRecalcularSaldoDeTarjetas && (
              <RecalcularSaldoDeTarjetas onRedirect={setActiveView} />
            )}
          {/* // ===== Reiniciar Saldos de Tarjetas=====*/}
          {activeView === "reiniciarSaldosDeTarjetas" &&
            canReiniciarSaldosDeTarjetas && (
              <ReinicioSaldoDeTarjetas onRedirect={setActiveView} />
            )}
          {/* // ===== Listado de Archivos=====*/}
          {activeView === "listadoDeArchivos" && canListadoDeArchivos && (
            <ListadoDeArchivos />
          )}
          {/* // ===== Ejecutar proceso de Liquidacion=====*/}
          {activeView === "ejecutarProcesoDeLiquidacion" &&
            canEjecutarProcesoDeLiquidacion && (
              <EjecutarProcesoDeLiquidacion onRedirect={setActiveView} />
            )}
          {/* // ===== Generar Archivo SAP =====*/}
          {activeView === "generarArchivoSap" && canGenerarArchivosSap && (
            <GenerarArchivoSap />
          )}
          {/* // =====Importar Archivo SAP =====*/}
          {activeView === "importarArchivoSap" && canImportarArchivoSap && (
            <ImportarArchivoSap />
          )}
          {/* // ===== Parametros =====*/}
          {activeView === "datosParametros" && canParametrosGenerales && (
            <ParametrosGenerales /> // TODO: importar componente cuando exista
          )}
          {activeView === "listarInformacion" && canInformacion && (
            <EstadosFlujosInformacion /> // TODO
          )}
          {activeView === "listarTipoEstados" && canTiposEstado && (
            <TiposEstado /> // TODO
          )}
          {activeView === "listarEstados" && canEstados && (
            <Estados /> // TODO
          )}
          {activeView === "listarProcesos" && canProcesos && (
            <Procesos /> // TODO
          )}
          {/* // ===== Catálogos Comerciales  =====*/}
          {activeView === "listarRubro" && canRubros && <ListarRubro />}
          {activeView === "listarMarca" && canMarcas && <ListarMarca />}
          {/* // ===== Gegografía  =====*/}
          {activeView === "listarZona" && canZonas && <ListarZona />}
          {activeView === "listarCiudad" && canCiudades && <ListarCiudad />}
          {activeView === "listarDepartamento" && canDepartamentos && (
            <ListarDepartamento />
          )}
          {/* // ===== Fiscales  =====*/}
          {activeView === "listarMoneda" && canMonedas && <ListarMoneda />}
          {activeView === "listarIva" && canIvas && <ListarIva />}
          {/* Auditoria */}
          {activeView === "auditoria" && canAuditoria && <ListarAuditoria />}
          {activeView === "transaccionBancard" && canTransaccionBancard && (
            <ListarTransaccionesBancard />
          )}
          {activeView === "datosExportadosProani" && canExport && (
            <ListarDatosExportadosProani />
          )}
          {/* Reporte de Clientes */}
          {activeView === "reportePinesClientes" && canReportePinesClientes && (
            <ReportePinesDeClientes />
          )}
          {activeView === "reporteListadoDeTarjetas" &&
            canReporteListadoDeTarjetas && <ReporteListadoDeTarjetas />}
          {activeView === "reporteProductosAsignados" &&
            canReporteProductosAsignados && (
              <ReporteProductosAsignadosTarjetasPorCuenta />
            )}
          {activeView === "reporteDetalleFacturacionCliente" &&
            canReporteDetalleFacturacionCliente && (
              <ReporteDetalleFacturacionCliente />
            )}
          {activeView === "reporteDetalleUtilizacionTarjetas" &&
            canReporteDetalleUtilizacionTarjetas && (
              <ReporteDetalleUtilizacionTarjetas />
            )}
          {activeView === "reporteDetalleTarjetasConDescuento" &&
            canReporteDetalleTarjetasConDescuento && (
              <ReporteDetalleTarjetasConDescuento />
            )}
          {activeView === "listarDetalleUtilizacionDescuentoISC" &&
            canDetalleUtilizacionDescuentoISC && <ListarTarjetaDescISC />}
          {activeView === "listarTransaccionesManuales" &&
            canDetalleTransaccionesManuales && <ListarTransaccionesManuales />}
          {activeView === "reporteFacturacionClientes" &&
            canDetalleFacturacionClientes && <ReporteFacturacionClientes />}
          {activeView === "detalleUtilizacionTarjetaEess" &&
            canReporteDetalleUtilizacionTarjetasEESS && (
              <ReporteDetalleUtilizacionTarjetaEess />
            )}
          {activeView === "reporteAcreditacionEess" &&
            canAcreditacionDeEess && <ReporteAcreditacionEess />}
          {activeView === "listarTarjetasMaestras" &&
            canListarTarjetasMaestras && <ListadoDeTarjetasMaestras />}
          {activeView === "listarPinesEstaciones" && canListarPinesEess && (
            <ListadoDePinesEess />
          )}
          {/* Resumen Liquidacion */}
          {activeView === "resumenLiquidacion" && canResumenLiquidacion && (
            <ListarResumenLiquidacion />
          )}
        </main>

        {/* ===== FOOTER ===== */}
        <footer
          style={{
            backgroundColor: "white",
            padding: "1rem",
            textAlign: "right",
            marginTop: "2rem",
            fontSize: "0.85rem",
            color: "#6b7280",
          }}
        >
          <p style={{ margin: 0 }}>
            Copyright © Petrobras 2016. Todos los derechos reservados.
          </p>
          <p style={{ margin: 0 }}>
            Atención al cliente Flota:{" "}
            <a
              href="mailto:petrobrasflota@nextar.com.py"
              style={{ color: "inherit", textDecoration: "underline" }}
            >
              petrobrasflota@nextar.com.py
            </a>
          </p>
        </footer>
      </div>

      {/* Modal confirmación */}
      {showModal && (
        <div className="modal-backdrop-old" onClick={() => setShowModal(false)}>
          <div className="modal-card-old" onClick={(e) => e.stopPropagation()}>
            <h2 className="text-lg font-semibold mb-4">
              ¿Deseás cerrar sesión?
            </h2>
            <div className="flex justify-center gap-4">
              <button onClick={handleLogout} className="btn-red-old">
                Confirmar
              </button>
              <button
                onClick={() => setShowModal(false)}
                className="btn-gray-old"
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
